import { OnboardingStepProps } from '../types';

import VsimavecHead from '../../../assets/vsimavec-head.svg';
import { Button } from '../../buttons/Button';
import {
    UilApps,
    UilBookAlt,
    UilBrain,
    UilGraduationCap,
    UilInfoCircle,
} from '@iconscout/react-unicons';
import Tabs from '../../tabs/Tabs';
import { useState } from 'react';
import Tooltip from '../../tooltip/Tooltip';
import { Video } from '../Video';

export function StepHowWeHelp({ onNext, category }: OnboardingStepProps) {
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);

    const tabs = [
        {
            id: 'vedeni-skoly',
            label: 'Vedení školy',
            icon: UilGraduationCap,
            tooltip: 'Ředitel / Zástupce',
            content: <Video slug="vedeni-skoly" category={category} />,
        },
        {
            id: 'pracovnik-spp',
            label: 'Pracovník ŠPP',
            icon: UilBrain,
            tooltip: 'Školní psycholog / Metodik prevence / Speciální pedagog',
            content: <Video slug="pracovnik-spp" category={category} />,
        },
        {
            id: 'pedagogicky-pracovnik',
            label: 'Pedagogický pracovník',
            icon: UilBookAlt,
            tooltip: 'Učitel / Asistent / Vychovatel',
            content: <Video slug="pedagogicky-pracovnik" category={category} />,
        },
        {
            id: 'jina-instituce',
            label: 'Jiná instituce',
            icon: UilApps,
            tooltip:
                'Dětské domovy / Pedagogicko psychologické poradny /<br />Střediska volného času / Domovy mládeže /<br />Neziskové organizace pracující s dětmi',
            content: <Video slug="jina-instituce" category={category} />,
        },
    ];

    return (
        <>
            {/* Header */}
            <div className="text-center">
                <div className="mx-auto mb-6 w-20">
                    <img
                        src={VsimavecHead}
                        alt="Logo"
                        className="h-full w-full object-contain"
                    />
                </div>
                <h1 className="text-5xl">
                    Jak vám Všímavec pomůže ve vaší práci?
                </h1>
                <p className="mb-6 text-ink-800">
                    Zjistěte, v jakých situacích Všímavce využijete a co vám
                    přinese z pohledu vaší role.
                </p>
            </div>

            <div className="w-full flex-1">
                <Tabs
                    heading={null}
                    state={[selectedTabIndex, setSelectedTabIndex]}
                    tabs={tabs.map((role) => ({
                        id: role.id,
                        label: (
                            <div className="flex items-center gap-2">
                                <role.icon size={16} />
                                {role.label}
                                <Tooltip label={role.tooltip}>
                                    <UilInfoCircle size={16} />
                                </Tooltip>
                            </div>
                        ),
                        content: role.content,
                    }))}
                    variant="onboarding"
                />
            </div>

            {/* Role Selection */}
            {/* <div className="">
                {roleOptions.map((role) => (
                    <button
                        key={role.id}
                        onClick={() => onRoleSelect(role.id)}
                        className={cn(
                            'flex items-center gap-2 rounded-[11px] border px-4 py-2 transition-colors',
                            selectedRole === role.id
                                ? 'border-product-500 bg-product-500 text-white'
                                : 'border-cloud-300 bg-cloud-200 text-ink-800 hover:bg-cloud-300'
                        )}
                    >
                        <role.icon />
                        <img
                            src={role.icon}
                            alt={role.label}
                            className="h-5 w-5"
                        />
                        <span className="text-[16px] font-semibold">
                            {role.label}
                        </span>
                    </button>
                ))}
            </div> */}

            {/* Button */}
            <div className="flex w-full max-w-[540px] flex-col gap-2">
                <Button
                    color="product"
                    className="text-base"
                    onClick={() => onNext('target-audience')}
                    // className="bg-product-500 hover:bg-product-600 text-white font-bold text-[20px] w-[545px] h-[45px] rounded-[12px] transition-colors"
                >
                    Pokračovat
                </Button>
            </div>
        </>
    );
}
